// extracted by mini-css-extract-plugin
module.exports = {"corteTransaccionChildren":"corteTransaccion_corteTransaccionChildren__1tCjj"};